import { makeObservable, observable } from 'mobx'

import { EMPTY_NUMBER_ID } from '@/constant/common'
import { DTO } from '../DTO'
import { Student } from '../Student'

type ConstructorParams = Partial<Pick<LessonClassWithStudentId, 'id' | 'name' | 'memberList'>>

// TODO: 나중에 백엔드 API 추가되거나 생기면 바꿔야 함
export class LessonClassWithStudentId extends DTO {
  id = EMPTY_NUMBER_ID
  name = ''
  memberList: { id: Student['id'] }[] = []

  constructor(params: ConstructorParams) {
    super()
    makeObservable(this, {
      id: observable,
      name: observable,
      memberList: observable,
    })
    this.update(params)
  }
}
